import add from 'date-fns/add'
import endOfMonth from 'date-fns/endOfMonth'
import isSameMonth from 'date-fns/isSameMonth'

/** Returns a calendar-month range with an exclusive end date. */
export const getDateRange = (date: Date, minDate: Date, maxDate: Date): [Date, Date] => {
  const fromDate = isSameMonth(date, minDate) ? minDate : date
  const toDate = isSameMonth(fromDate, maxDate) ? maxDate : endOfMonth(fromDate)

  return [fromDate, add(toDate, { days: 1 })]
}
